import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PublicationService } from '@sparro/app/core/api/publication/publication.service';
import { BlogService } from '@sparro/app/core/api/blog/blog.service';
import { HttpEventType } from '@angular/common/http';
import { ToastrService } from '@sparro/app/core/helpers/toastr/toastr.service';
import { BreakpointObserver} from '@angular/cdk/layout';
import { BREAKPOINTS } from '@sparro/app/core/config/constants.config';


@Component({
  selector: 'uni-thumbnail-uploader',
  templateUrl: './thumbnail-uploader.component.html',
  styleUrls: ['./thumbnail-uploader.component.scss']
})
export class ThumbnailUploaderComponent implements OnInit {
  @Input() image: string;
  @Input() view: 'landscape' | 'potrait' = 'potrait';
  @Input() type: string;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() uuid: string;
  @Output() media = new EventEmitter();

  mobileView: boolean = false;

  constructor(
    public publicationService: PublicationService,
    public journalService: BlogService,
    public toastr: ToastrService,
    public breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {
    this.initializeBreakpoints();
  }

  initializeBreakpoints() {
    this.breakpointObserver.observe([
      BREAKPOINTS.below.md,
    ]).subscribe(result => {
      if (result.breakpoints[BREAKPOINTS.below.md] != this.mobileView){
        this.mobileView = !this.mobileView;
      }
    });
  }

  onFileChanged(event) {
    const item = event.target.files[0];

    if (item.size > 15000000) {
      this.toastr.error('Please upload image less than 15mb');
    } else {
      this.startCoverUpload(item);
    }
  }

  startCoverUpload(file) {
    const thumbnail_fd = new FormData();
    thumbnail_fd.append('uuid', this.uuid);
    thumbnail_fd.append('title', '');
    thumbnail_fd.append('description', '');
    thumbnail_fd.append('file', file, file.name);
    thumbnail_fd.append('type', 'cover');
    this.uploadCoverImage(thumbnail_fd);
  }

  uploadCoverImage(fileData) {
    if (this.type == 'Publication') {
      this.publicationService.uploadPublicationCoverImage(fileData).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.Response) {
            this.toastr.success('Thumbnail image uploaded successfully!');
            this.media.emit(event.body);
          }
        }, (err) => {
          console.log(err);
        }
      );
    }
    else if (this.type == 'Blog'){
      this.journalService.uploadBlogCover(fileData).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.Response) {
            this.toastr.success('Thumbnail image uploaded successfully!');
            this.media.emit(event.body);
          }
        }, (err) => {
          console.log(err);
        }
      );
    }
  }

  deleteThumbnail(){
    if (this.type == 'Publication') {
      this.publicationService.removePublicationCover(this.uuid).subscribe(
        (response: any) => {
          if (response.success) {
            this.toastr.success('Thumbnail image removed successfully!');
            this.media.emit(null);
          }
        }, (err) => {
          console.log(err);
        }
      )
    }else if (this.type == 'Blog') {
      this.journalService.removeBlogCover(this.uuid).subscribe(
        (response: any) => {
          if (response.success) {
            this.toastr.success('Thumbnail image removed successfully!');
            this.media.emit({image: ''});
          }
        }, (err) => {
          console.log(err);
        }
      )
    }
  }
}
